export const stateSelector = state => state;
export const savesSelector = ({ saves }) => saves;
export const directorySelector = ({ directory }) => directory;
export const gameDataSelector = ({ gameData }) => gameData;
export const gameStateSelector = ({ gameState }) => gameState;
export const cursorSelector = ({ gameState }) => gameState?.cursor;
export const gameIdSelector = ({ gameId }) => gameId;
export const isReadySelector = ({ gameData }) => !!gameData;
export const isLoadingSelector = ({ isLoading }) => isLoading;
